import { modelsBedroom } from "./modelsBedroom";
import { modelsBedroomPresets } from "./modelsBedroomPresets";
import { modelsChairs } from "./modelsChairs";
import { modelsClassicSofa } from "./modelsClassicSofa";
import { modelsClassicSofaPresets } from "./modelsClassicSofaPresets";
import { modelsHeadboards } from "./modelsHeadboards";
import { modelsOttomans } from "./modelsOttomans";
import { modelsSectionalPresets } from "./modelsSectionalPresets";
import { modelsSectionalSections } from "./modelsSectionalSections";

export const Models = {
  sofa: [
    {
      title: "Our Bestsellers",
      subtitle: "Designed for real life",
      values: modelsClassicSofaPresets,
    },
    {
      title: "Start from scratch",
      subtitle: "Please select a product type to begin customization",
      values: modelsClassicSofa,
    },
  ],
  sectional: [
    {
      title: "Our Bestsellers",
      subtitle: "Designed for real life",
      values: modelsSectionalPresets,
    },
    {
      title: "Build Your Sectional",
      subtitle: "Start with any piece, shape it your way",
      values: modelsSectionalSections,
    },
  ],
  ottoman: [
    {
      title: "Start from scratch",
      subtitle: "Please select a product type to begin customization",
      values: modelsOttomans,
    },
  ],
  pillows: [],
  chair: [
    {
      title: "Start from scratch",
      subtitle: "Please select a product type to begin customization",
      values: modelsChairs,
    },
  ],
  bed: [
    {
      title: "Our Bestsellers",
      subtitle: "Designed for real life",
      values: modelsBedroomPresets,
    },
    {
      title: "Choose your bed to start customizing",
      subtitle: "Select a size, then make it yours",
      values: modelsBedroom,
    },
    {
      title: "Prefer a headboard only?",
      subtitle: "Choose your style to begin",
      values: modelsHeadboards,
    },
  ],
};
